module.exports = __webpack_public_path__ + "static/media/app-store-badge.371ef16d.png";